import * as React from "react";
import type { SVGProps } from "react";
const SvgOverdueClockStatus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.764 6.653v3.878l3.048 1.858"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.545 9.167a7.503 7.503 0 1 1 7.454 8.337"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.662 13.668v2.334c0 .645.523 1.168 1.167 1.168h3.502c.644 0 1.167-.523 1.167-1.168v-2.334c0-.644-.523-1.167-1.167-1.167H2.829c-.644 0-1.167.523-1.167 1.167"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.498 14.669H1.662"
    />
  </svg>
);
export default SvgOverdueClockStatus;
